import { SilentRequest } from '@azure/msal-browser';
import { createReducer, on } from '@ngrx/store';
import { setPartner, setUser } from './user.actions';
import { IUser } from './user.models';


export const initialState: IUser = {};

export const userReducers = createReducer(
    initialState,

    on(setUser, (state, { accountInfo }) => accountInfo),
    on(setPartner, (state, { partner }) => { return { ...state, partner: partner } }),
);